import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import libraryProjectsAndListsQuery from '../../queries/libraryProjectsAndLists';
// import CategoriesDistributionPieCard from '../components/shared/charts/categoriesDistributionPieCard.vue';
import LicensesCountCard from '../shared/charts/licensesCountCard.vue';
import LoansCountCard from '../shared/charts/loansCountCard.vue';
import ResourcesCountCard from '../shared/charts/resourcesCountCard.vue';
// import LoansDistributionPieCard from '../components/shared/charts/loansDistributionPieCard.vue';
// import PurchasesCard from '../components/shared/charts/purchasesCard.vue';
import IconText from '../shared/iconText.vue';
import SectionTitle from '../shared/sectionTitle.vue';
import SingleMainContainer from '../shared/singleMainContainer.vue';
import ProjectEditor from './projectEditor.vue';
import ProjectsGrid from './projectsGrid.vue';
import SuggestionsListsGrid from './suggestionsListsGrid.vue';
import { ViewerContext } from '../../types/viewer_context';

@Component({
  components: {
    IconText,
    ProjectsGrid,
    SingleMainContainer,
    SectionTitle,
    LicensesCountCard,
    LoansCountCard,
    ResourcesCountCard,
    ProjectEditor,
    SuggestionsListsGrid,
  },
})
export default class Dashboard extends Vue {
  @Getter public viewerContext!: ViewerContext;

  // the query we want to refetch then a new project is created.
  public readonly refetchQueryForGrid = libraryProjectsAndListsQuery;

  public openProjectEditor() {
    const editor = this.getProjectEditor();
    editor.show();
  }

  private getProjectEditor(): any {
    return this.$refs.projectEditor;
  }
}
